import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import SwitchDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/SwitchDemo";
import CustomTaskDescriptionDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CustomTaskDescriptionDemo";
import TitledTextDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/TitledTextDemo";
import TitledBoxedTextDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/TitledBoxedTextDemo";
import CompletableChecklistDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CompletableChecklistDemo";
import styles from "./ComponentDemoPage.module.css";
import AddImagesDemo from "./demos/AddImagesDemo";
import AssignToDemo from "./demos/AssignToDemo";
import LoadingViewerTopDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/LoadingViewerTopDemo";
import MenuSheetDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/MenuSheetDemo";
import AttachArticlesDemo from "./demos/AttachArticlesDemo";
import TaskScheduleDemo from "./demos/TaskScheduleDemo";
import CloseSheetDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CloseSheetDemo";
import PersonAndTeamDemo from "./demos/PersonAndTeamDemo";
import AttachFilesDemo from "./demos/AttachFilesDemo";
import RefillQuantityDemo from "./demos/RefillQuantityDemo";
import PendingTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/PendingTaskCardDemo";
import ClosedTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/ClosedTaskCardDemo";
import CompletedTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CompletedTaskCardDemo";
import TextModalDemo from "./demos/TextModalDemo";
import LoadingTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/LoadingTaskCardDemo";
import PickupAndRefillLocationDemo from "./demos/PickupAndRefillLocationDemo";
import ImagesDemo from "./demos/ImagesDemo";
import FilesDemo from "./demos/FilesDemo";
import LogsAndCommentsDemo from "./demos/LogsAndCommentsDemo";
import SelectItemWithDescriptionDemo from "./demos/SelectItemWithDescriptionDemo";
import MultipleArticlesTopDemo from "./demos/MultipleArticlesTopDemo";
import SelectItemSheetDemo from "./demos/SelectItemSheetDemo";
import AddLocationDemo from "./demos/AddLocationDemo";
import AttachArticleDemo from "./demos/AttachArticleDemo";
import TitledHeadingTextDemo from "./demos/TitledHeadingTextDemo";
import TaskInfoPanelDemo from "./demos/TaskInfoPanelDemo";
import TitledTextAreaDemo from "./demos/TitledTextAreaDemo";
import MultipleArticlesDemo from "./demos/MultipleArticlesDemo";
import SelectItemDemo from "./demos/SelectItemDemo";
import TitledTextAreaViewerFragmentDemo from "./demos/TitledTextAreaViewerFragmentDemo";
import TitledHeadingTextViewerTopFragmentDemo from "./demos/TitledHeadingTextViewerTopFragmentDemo";
import TitledTextWithModalDemo from "./demos/TitledTextWithModalDemo";
import BannerFieldCardFragmentDemo from "./demos/BannerFieldCardFragmentDemo";
import ArticlesPrintPTagAndQuantityAcknowledgeDemo from "./demos/ArticlesPrintPTagAndQuantityAcknowledgeDemo";

function ComponentDemoPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Task management components" currentAsH1 />
      <FullscreenContent className={styles["fullscreenContent"]}>
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task creation fragments
        </FixaText>
        <FixaText tagName="h3" textStyle="Heading.L">
          Settings
        </FixaText>
        <AddImagesDemo />
        <AssignToDemo />
        <AttachFilesDemo />
        <SwitchDemo />
        <TaskScheduleDemo />
        <FixaText tagName="h3" textStyle="Heading.L">
          Other
        </FixaText>
        <AddLocationDemo />
        <AttachArticleDemo />
        <AttachArticlesDemo />
        <MultipleArticlesDemo />
        <CustomTaskDescriptionDemo />
        <TitledHeadingTextDemo />
        <TitledTextAreaDemo />
        <TaskInfoPanelDemo />
        <PickupAndRefillLocationDemo />
        <RefillQuantityDemo />
        <SelectItemSheetDemo />
        <SelectItemDemo />
        <SelectItemWithDescriptionDemo />
        <TextModalDemo />
        <TitledTextWithModalDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task viewer top fragments
        </FixaText>
        <CloseSheetDemo />
        <MenuSheetDemo />
        <LoadingViewerTopDemo />
        <MultipleArticlesTopDemo />
        <TitledHeadingTextViewerTopFragmentDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task viewer fragments
        </FixaText>
        <ImagesDemo />
        <FilesDemo />
        <CompletableChecklistDemo />
        <LogsAndCommentsDemo />
        <PersonAndTeamDemo />
        <ArticlesPrintPTagAndQuantityAcknowledgeDemo />
        <TitledBoxedTextDemo />
        <TitledTextDemo />
        <TitledTextAreaViewerFragmentDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task cards
        </FixaText>
        <BannerFieldCardFragmentDemo />
        <PendingTaskCardDemo />
        <CompletedTaskCardDemo />
        <ClosedTaskCardDemo />
        <LoadingTaskCardDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default ComponentDemoPage;
